import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewEncapsulation,
  ElementRef,
  Inject,
  AfterViewInit,
} from '@angular/core';
import { NavItem } from 'epubjs/types/navigation';
import { EpubRenderService } from '../../services/rendition/epubrender.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DeviceDetectorService } from '../../../util/device-detector/device-detector.service';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'app-table-contents',
  templateUrl: './table-contents.component.html',
  styleUrls: ['./table-contents.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class TableContentsComponent implements OnInit, AfterViewInit {
  public activatedView = 'book';

  tocValue: any;
  @Input() tableOfContentsOpened: boolean | undefined;
  @Input() chapters: NavItem[] | undefined;
  @Input() toc: any;
  @Output() onNavigate = new EventEmitter<any>();
  @Output() onToggleTableOfContents = new EventEmitter<any>();
  @Output() onTogglePanel = new EventEmitter<any>();

  constructor(
    private rendering: EpubRenderService,
    public sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    public deviceDetector: DeviceDetectorService,
    @Inject(L10N_LOCALE) public locale: L10nLocale
  ) {}

  ngOnInit() {
    if (this.toc) {
      this.tocValue = this.sanitizer.bypassSecurityTrustHtml(this.toc);
    }
  }

  ngAfterViewInit(): void {
    this.setUpTOC();
  }

  setUpTOC(): void {
    let ul = this.elementRef.nativeElement.shadowRoot.querySelector('#TOC');
    if (ul) {
      let anchors = ul.querySelectorAll('a');
      for (let anchor of anchors) {
        anchor.addEventListener('click', () => {
          this.goToPageToc(anchor.id);
        });
      }
    }
  }

  private exitEditor() {
    this.onTogglePanel.emit({ navigateTo: 'book', editing: false });
  }
  public goToPageToc(href: string) {
    this.rendering.getCfiFromHref(href).then((cfi) => {
      if (cfi) {
        this.rendering.goToCfi(cfi).then(() => {
          this.onNavigate.emit(cfi);
          const hash = href.substring(href.indexOf('#'));
          setTimeout(() => {
            this.rendering.goToSubSection(hash);
          }, 500);
        });
      }
    });
  }

  /**
   * This functions directs the user to specific chapter, sub chapter or item in the book.
   */

  public goToSpecificPage(chapter: NavItem) {
    const href = chapter.href;
    this.rendering.getCfiFromHref(href).then((cfi) => {
      if (cfi) {
        this.rendering.goToCfi(cfi).then(() => {
          this.onNavigate.emit(cfi);
        });
      }
    });
  }
}
